import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { authActions, alertActions } from "../../../_actions";
import NotificationSystem from "react-notification-system";
import CustomButton from "../../utils/ButtonComponent";
import NcaaLogo from "../assets/logo-ncaa.png";
import Logo from "../assets/logo.png";
import IconPhone from "react-icons/lib/md/phone-in-talk";
import IconEmail from "react-icons/lib/md/email";
import MdRemoveRedEye from "react-icons/lib/md/remove-red-eye";
import MdVisibilityOff from "react-icons/lib/md/visibility-off";
import CookiesConsent from "../cookies-page/cookies-consent";
import {
  Form,
  Input,
  Label,
  FormGroup,
  FormText,
  Card,
  CardBlock,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import "../style.css";
import "../style.scss";
import { alertConstants, appConstants } from "../../../_constants";
import { appHelpers } from "../../../_helpers";
import EyeIcon from "../../../_assets/icons/Eye.svg"
import EyeClose from "../../../_assets/icons/eyeslash.svg"


class SignInView extends React.Component {
  constructor(props) {
    super(props);

    // reset login status
    this.props.dispatch(authActions.logout());

    this.state = {
      username: "",
      password: "",
      error: false,
      componentError: false,
      success: false,
      isRequesting: false,
      FORGOT_PASSWORD: appConstants.FORGOT_PASSWORD_URL,
      modal: false,
      modalClass: "",
      cookieName: "avicollectweb:cc",
      showPassword: false,
    };

    this.validateInput = this.validateInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.processSubmit = this.processSubmit.bind(this);
    this.resetError = this.resetError.bind(this);
    this.renderPageResponse = this.renderPageResponse.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  }

  //cookies
  setCookies = (name, value, days) => {
    let expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    this.toggleCookieDisplay();
  };

  getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  toggleCookieDisplay = () => {
    const { cookieName } = this.state;
    let cookieObj = this.getCookie(cookieName);
    console.log(cookieObj, typeof cookieObj);
    let cookieWrapperElement = document.querySelector(".cookies-poilcy-footer");
    if (cookieObj === null) {
      console.log("it is null");
      cookieWrapperElement.style.display = "flex";
    } else {
      console.log("it is not null");
      cookieWrapperElement.style.display = "none";
    }
  };

  componentDidMount() {
    if (appHelpers.getSessionErrorMessage()) {
      this.setState({ componentError: appHelpers.getSessionErrorMessage() });
      appHelpers.destroySessionExpired();
    }
    this.toggleCookieDisplay();
  }

  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        this.setState({ error: false, success: alert.message });
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
  };

  validateInput = () => {
    if (this.state.username === "") {
      this.setState({ componentError: "Please enter username" });
    } else if (this.state.password === "") {
      this.setState({ componentError: "Please enter password" });
    } else {
      this.setState({ componentError: false });
      return true;
    }
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    this.setState(currState);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      // console.log('Submitting...');
      this.processSubmit();
    }
  };

  processSubmit = () => {
    const { username, password } = this.state;
    const { dispatch } = this.props;
    dispatch(authActions.login(username, password))
      .then(this.setState({ isRequesting: false }))
      .catch(this.setState({ isRequesting: false }));
  };

  resetError() {
    this.props.dispatch(alertActions.clear());
  }

  togglePasswordVisibility() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }
  renderPageResponse() {
    if (this.state.error) {
      return (
        <div className="alert alert-danger text-capitalize-first">
          {this.state.error}
        </div>
      );
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger text-capitalize-first">
          {this.state.componentError}
        </div>
      );
    } else if (this.state.success) {
      return (
        <div className="alert alert-success text-capitalize-first">
          {this.state.success}
        </div>
      );
    }
  }
  toggle = () => {
    const modalState = this.state.modal;
    this.setState({ modal: !modalState });
  };
  render() {
    let pageResponse = this.renderPageResponse();
    const { loggingIn } = this.props;
    const { cookieName, showPassword } = this.state;
    return (
      <div className="view">
        <div className="view-content view-pages view-session d-flex justify-content-center align-items-center flex-column">
          <Card className="mb-3 form-card">
            <CardBlock>
              <header className="mb-2">
                <Link to="/">
                  <div className={"pull-right"}>
                    <img src={NcaaLogo} alt="NCAA AviCollect" height="65px" />
                  </div>
                  <div className={"pull-left logo"}>
                    <img src={Logo} alt="NCAA AviCollect" height="65px" />
                  </div>
                  <div className="clearfix"></div>
                </Link>
                <p className="lead mt-2">Sign In to continue</p>
              </header>

              {pageResponse}

              <Form onSubmit={this.handleSubmit}>
                <FormGroup className="mb-4">
                  <Label>Email Address</Label>
                  <Input
                    type="email"
                    placeholder=""
                    value={this.state.username}
                    onChange={(event) => this.handleChange(event, "username")}
                  />
                </FormGroup>
                <FormGroup className="mb-2" style={{ position: 'relative' }}>
                  <Label>Password</Label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder=""
                    value={this.state.password}
                    onChange={(event) => this.handleChange(event, "password")}
                  />
                  <img
                    src={showPassword ? EyeIcon : EyeClose}
                    style={{ cursor: "pointer" }}
                    alt=""
                    width="15"
                    height="15"
                    onClick={this.togglePasswordVisibility}
                    className="custom-icon"
                  />
                  <FormText className="text-right">
                    <a target="_blank" href={this.state.FORGOT_PASSWORD}>
                      Forgot password?
                    </a>
                  </FormText>
                </FormGroup>
                <div className="text-right">
                  <CustomButton loading={loggingIn} buttonText={"Sign In"} />
                </div>
              </Form>
              <hr className={"mb-0"} />

              <div>
                <a
                  className={"mt-0 mb-0 small text-avi-primary pointer"}
                  href="/pages/customer-policy"
                >
                  Customer awareness policy
                </a>
                <br />
                <a
                  className={"mt-0 mb-0 small text-avi-primary pointer"}
                  href="/pages/privacy-page/"
                >
                  Privacy policy
                </a>
                <br />
                {/* <a
                  className={"mt-0 mb-0 small text-avi-primary pointer"}
                  href="/pages/faqs/"
                >
                FAQ</a> */}

                <span
                  className={
                    "mt-0 mb-0 small pull-right text-avi-primary pointer"
                  }
                  onClick={this.toggle}
                >
                  Terms & Condition
                </span>

                <br />
                <div className={"mt-0 mb-0 small pull-right"}>
                  <IconPhone /> 012803824
                </div>

                <div className={"mt-3 small pull-right fix-support"}>
                  <IconEmail /> support@avitechng.com
                </div>

                <div className="clearfix">&nbsp;</div>
              </div>

              {/*{ loggingIn &&  <div className={'loading-dot active'}></div>}*/}
            </CardBlock>

            {/*terms & Conditions*/}
            <Modal
              size={"lg"}
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.state.modalClass}
            >
              <ModalHeader toggle={this.toggle}>Terms & Conditions</ModalHeader>
              <ModalBody>
                <p>
                  Please read these terms and conditions carefully before
                  accessing the Nigerian Civil Aviation Authority (hereinafter
                  referred to as ëthe Authorityí) AVICOLLECT portal. As a
                  condition to and in consideration of accessing the AVICOLLECT
                  portal, airlines operating within Nigeria and participating
                  banks (hereinafter referred to as ìthe Userî) agree to be
                  bound by the terms of this Agreement. Use of or access to the
                  AVICOLLECT portal Website shall constitute acceptance of and
                  agreement to be bound by these Terms and Conditions.
                </p>
                <p>
                  Where any questions arise with regard to these terms and
                  conditions, please contact the Legal department of the
                  Authority. These TERMS AND CONDITIONS ëTerms and Conditionsí
                  is entered into by and between Nigerian Civil Aviation
                  Authority and any individual, corporation, association,
                  agency, company, or other entity who accesses or uses the
                  AVICOLLECT portal (the "User" or "you").
                </p>
                <h5>INTRODUCTION</h5>
                <p>
                  The Nigerian Civil Aviation Authority (NCAA) is a government
                  establishment which is regulated by the Civil Aviation Act
                  2006, No. 6. The Authority by the powers of the Civil Aviation
                  Act 2006 regulates all airlines operating within the Federal
                  Republic of Nigeria. The AVICOLLECT Portal is designed to
                  allow Nigerian Civil Authority have the current electronic
                  information about the Flight schedules, Flight Fares and
                  Passenger Manifests of all airlines operating within Nigeria
                  and also to calculate and have the Ticket Sales Charge (TSC)
                  remitted to the Nigerian Civil Aviation Authority as and at
                  when due. The AVICOLLECT portal also allows the Authority
                  amongst other functions to communicate with the airlines.
                </p>
                <p>
                  The Avicollect portal is owned and operated by the Nigerian
                  Civil Aviation Authority. The AVICOLLECT portal contains or
                  may contain information, communications, opinions, text,
                  graphics, links, electronic art, animations, audio, video,
                  software, photos, music, sounds and other material and data
                  (collectively, "Content") formatted, organized and collected
                  in a variety of forms that are generally accessible to Users,
                  including directories and databases, and areas of the
                  AVICOLLECT portal that can be modified by Users, such as
                  posting classifieds, uploading multimedia files, registering
                  user profiles, and creating auto-notify, personalized pages,
                  and personalized project areas.
                </p>
                <h5>USER RIGHTS AND RESPONSIBILITIES</h5>
                <h6>A. USER ACCESS TO THE AVICOLLECT PORTAL</h6>
                <p>
                  The user is responsible for providing all hardware, software,
                  telephone or other communications equipment and/or service
                  required to connect to the Internet and access the Avicollect
                  Portal and is responsible for all Internet access charges,
                  telephone charges or other fees or charges incurred in
                  connecting to the Internet and accessing the Avicollect port.
                </p>
                <h6>B. USER MATERIAL AND CONDUCT</h6>
                <p>
                  The user is responsible for providing all hardware, software,
                  telephone or other communications equipment and/or service
                  required to connect to the Internet and access the Avicollect
                  Portal and is responsible for all Internet access charges,
                  telephone charges or other fees or charges incurred in
                  connecting to the Internet and accessing the Avicollect port.
                </p>
                <p>
                  User(s) must not post or transmit to or from the Website any
                  material: (a) that is threatening, defamatory, obscene,
                  indecent, seditious, offensive, pornographic, abusive, liable
                  to incite racial hatred, discriminatory, menacing, scandalous,
                  inflammatory, blasphemous, in breach of confidence, in breach
                  of privacy or which may cause annoyance or inconvenience; or
                  (b) for which you have not obtained all necessary licenses
                  and/or approvals; or (c) which constitutes or encourages
                  conduct that would be considered a criminal offence, give rise
                  to civil liability, or otherwise be contrary to the law of or
                  infringe the rights of any third party, in any country in the
                  world; or (d) which is technically harmful (including, without
                  limitation, computer viruses, logic bombs, Trojan horses,
                  worms, harmful components, corrupted data or other malicious
                  software or harmful data). User(s) may not misuse the Website
                  (including, without limitation, by hacking).
                </p>
                <p>
                  DISCLAIMER This Website is here to give you information about
                  our products and services. It is up to the User to decide
                  whether such said products and services are suitable.
                </p>
                <p>
                  The information on the Website may not provide all the
                  information required by the User , you may forward questions
                  to the Authority or an independent financial advisor for more
                  details.
                </p>
                <p>
                  The Authority takes reasonable time and effort to ensure that
                  the information available on this website is accurate HOWEVER
                  the Authority cannot guarantee that the information is always
                  correct, complete or up-to-date. User(s) should not rely
                  solely on the information on this Website, details about
                  important issues like price or interest rates should be
                  confirmed in any actual agreement signed as it is the terms in
                  that document that form the agreement between the Authority
                  and the User. OUR AND YOUR LIABILITY FOR USE OF THIS WEBSITE
                </p>
                <p>
                  The Website only complies with the laws of the Federal
                  Republic of Nigeria. The portal should only be used within
                  Nigeria. The products and services on it are only available to
                  operating within or from Nigeria.
                </p>
                <p>
                  This website may not always be accessible. The Authority shall
                  not be responsible for any losses that arise out of the Userís
                  inability to access the website (for example if you cannot
                  upload download information to and from the system
                  respectively). The Authority shall not be responsible if the
                  means of communication used to access the Website, or to send
                  us information or to receive information from the Avicollect
                  portal does not work properly or cause a distortion in the
                  information provided from or to the server.
                </p>
                <p>
                  We re-iterate that the information on this Website may not
                  always be up to date or complete. We advise you to check it
                  carefully before you agree to perform an operation on the
                  Avicollect portal, and we shall not be responsible for any
                  losses suffered if you fail to do so except the information
                  provided on the website was incorrect or misleading. Whilst
                  the authority take reasonable care to ensure the accuracy of
                  information on third party websites (outside the Avicollect
                  portal) which we may have linked through this Website, the
                  Authority cannot control what they contain and shall therefore
                  not be responsible for any losses or other damage may suffered
                  a result of using those other websites.
                </p>
                <p>
                  The Authority shall not liable for losses or costs caused by
                  abnormal and unforeseeable circumstances outside our
                  reasonable control, which would have been unavoidable despite
                  all efforts to the contrary, for example delays or failures
                  caused by industrial action, problems with another system or
                  network, third party viruses or malware, mechanical breakdown
                  or data-processing failures.
                </p>
                <p>
                  Please note that electronic mailing is not a completely secure
                  means of communication: it may be possible for others to
                  intercept and read your messages. So if you choose to send us
                  information by email, it shall be at your own risk.
                </p>
                <p>
                  The Authority reserve the right to change our terms and
                  conditions as it governs the use of the Avicollect portal.
                </p>
              </ModalBody>
            </Modal>
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </div>
        <CookiesConsent setCookies={this.setCookies} cookieName={cookieName} />
      </div>
    );
  }
}

SignInView.propTypes = {
  loggingIn: PropTypes.bool,
  message: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { alert } = state;
  return {
    loggingIn,
    alert,
  };
}

export default connect(mapStateToProps)(SignInView);



// WEBPACK FOOTER //
// ./src/views/pages/signin/index.js